// AUTO-WA-39: ready-made templates for people new to WhatsApp Business.
// Picking one only pre-fills the create form; nothing is sent to Meta until
// the person reviews it and presses "Submit for review".

let buttonId = 0;
const button = (type, text, extra = {}) => ({ id: `ex${buttonId += 1}`, type, text, url: '', phone_number: '', example: '', ...extra });

export const TEMPLATE_EXAMPLES = [
  {
    id: 'order_confirmation', title: 'Order confirmation', use: 'Thank a customer and confirm what they ordered.', category: 'UTILITY',
    body: 'Hi {{1}}, thank you for your order {{2}}! We are packing it now and will message you when it is on the way.',
    examples: ['Asha', '#1042'], buttons: [button('QUICK_REPLY', 'Talk to us')],
  },
  {
    id: 'delivery_update', title: 'Out for delivery', use: 'Let people know their order arrives today.', category: 'UTILITY',
    body: 'Good news {{1}}! Your order {{2}} is out for delivery and will reach you today between {{3}}.',
    examples: ['Asha', '#1042', '4 and 7 pm'], buttons: [button('QUICK_REPLY', 'Change time')],
  },
  {
    id: 'payment_reminder', title: 'Payment reminder', use: 'A polite nudge before a payment is due.', category: 'UTILITY',
    body: 'Hi {{1}}, a gentle reminder that ₹{{2}} for invoice {{3}} is due on {{4}}. Reply here if you have any questions.',
    examples: ['Asha', '2,450', 'INV-208', '5 October'], buttons: [button('QUICK_REPLY', 'Paid already')],
  },
  {
    id: 'appointment_reminder', title: 'Appointment reminder', use: 'Cut no-shows with a reminder people can confirm.', category: 'UTILITY',
    body: 'Hi {{1}}, this is a reminder of your appointment on {{2}} at {{3}}. Please confirm or tell us if you need a new time.',
    examples: ['Asha', 'Friday, 4 October', '11:30 am'], buttons: [button('QUICK_REPLY', 'Confirm'), button('QUICK_REPLY', 'Reschedule')],
  },
  {
    id: 'festive_offer', title: 'Festive offer', use: 'Share a limited-time discount with your customers.', category: 'MARKETING',
    body: 'Namaste {{1}}! 🎉 Celebrate with us: get {{2}} off on all orders until {{3}}. Reply to this message to order.',
    examples: ['Asha', '15%', 'Sunday'], footer: 'Reply STOP to stop offers', buttons: [button('QUICK_REPLY', 'Show me'), button('QUICK_REPLY', 'Stop offers')],
  },
  {
    id: 'back_in_stock', title: 'Back in stock', use: 'Tell interested people a popular item is available again.', category: 'MARKETING',
    body: 'Hi {{1}}, {{2}} is back in stock! It sold out quickly last time, so reply now to reserve yours.',
    examples: ['Asha', 'Kaju katli'], footer: 'Reply STOP to stop offers', buttons: [button('QUICK_REPLY', 'Reserve one'), button('QUICK_REPLY', 'Stop offers')],
  },
  {
    id: 'feedback_request', title: 'Ask for feedback', use: 'Learn how a customer felt after an order or visit.', category: 'MARKETING',
    body: 'Hi {{1}}, thank you for choosing us! How was your experience? Tap a button below, it takes one second.',
    examples: ['Asha'], buttons: [button('QUICK_REPLY', 'Loved it'), button('QUICK_REPLY', 'It was okay'), button('QUICK_REPLY', 'Not happy')],
  },
  {
    id: 'welcome_message', title: 'Welcome message', use: 'Greet new customers and invite them to chat.', category: 'MARKETING',
    body: 'Welcome to {{1}}, {{2}}! 👋 Save this number to get updates and offers. Reply anytime and our team will help you.',
    examples: ['Sharma Sweets', 'Asha'], buttons: [button('QUICK_REPLY', 'Say hello')],
  },
];

export const exampleById = (id) => TEMPLATE_EXAMPLES.find((example) => example.id === id) || null;

// A create-form value (see TemplatePage EMPTY_FORM) filled from an example.
export function formFromExample(example, emptyForm) {
  if (!example) return null;
  return {
    ...emptyForm,
    name: example.id,
    category: example.category,
    template_type: 'STANDARD',
    header: { ...emptyForm.header },
    body: { text: example.body, examples: [...example.examples] },
    footer: { text: example.footer || '' },
    buttons: example.buttons.map((item) => ({ ...item })),
  };
}
